import React from 'react';
import styled from 'styled-components';
import Item, { Section, Content, Button } from './item';
import { offsets, fontSizes, colors } from '../../../styles';

const Price = styled(Section)`
  font-size: ${fontSizes.sm};
  color: ${colors.black};
`;

const LanchItem = ({ id, name, price, pictureId, consistsOf = null, weight = null}) => (
  <Item
    id={id}
    imgUrl={require(`../../../images/menu-pics/${pictureId}.png`)}
    imgAlt={`lanch-${id}`}
    name={name}
  >
    {
      consistsOf && (
        <Section>
          <b>Состав:</b>&nbsp;
         <span dangerouslySetInnerHTML={{__html:consistsOf}}/>
        </Section>
      )
    }
  
    {
      weight && (
        <Section>
          <b>Вес</b>: {weight} гр
        </Section>
      )
    }
    <Price>
      <b>Цена</b>: {price} р
    </Price>
  </Item>
);

export default LanchItem;
